const transformNumber = function (val) {
  if (!val) {
    return 0;
  }

  return Number(val.toString().replace(/[^0-9.-]+/g, ""));
};

export default transformNumber;
export { transformNumber };
